@if (isMobileView && banners.length > 1) {
<mat-accordion class="banner-accordion">
  <mat-expansion-panel
    class="banner-expansion-panel"
    expanded
  >
    <mat-expansion-panel-header>
      <mat-panel-title>{{banners.length}} Banners</mat-panel-title>
      <mat-panel-description>
        <mat-icon>warning</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="banner-container">
      @for (banner of banners; track banner) {
      <div class="{{banner.Type}} banner"> <mat-icon>{{getIcon(banner)}}</mat-icon> <span> {{banner.Text}}</span></div>
      }
    </div>
  </mat-expansion-panel>
</mat-accordion>
}
@else {
<div class="banner-container">
  @for (banner of banners; track banner) {
  <div class="{{banner.Type}} banner"> <mat-icon>{{getIcon(banner)}}</mat-icon> <span> {{banner.Text}}</span></div>
  }
</div>
}
